module.exports = __webpack_public_path__ + "c6c857cbcb0e0e03319a7c31066053d2.ttf";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/proxima-nova/2E6388_2_0.ttf
// module id = 536
// module chunks = 0